(function () {
  'use strict';

  function legacyCopyText(value) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');

      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.top = '0';
      textarea.style.opacity = '0';

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      try {
        var copied = document.execCommand('copy');
        document.body.removeChild(textarea);

        if (copied) {
          resolve();
        } else {
          reject(new Error('Copy command was not accepted.'));
        }
      } catch (error) {
        document.body.removeChild(textarea);
        reject(error);
      }
    });
  }

  function copyText(value) {
    if (
      window.isSecureContext &&
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === 'function'
    ) {
      return navigator.clipboard.writeText(value).catch(function () {
        return legacyCopyText(value);
      });
    }

    return legacyCopyText(value);
  }

  function buildShareUrl(productUrl) {
    var url;

    try {
      url = new URL(productUrl || window.location.href, window.location.origin);
    } catch (error) {
      url = new URL(window.location.href);
    }

    url.searchParams.set('utm_source', 'customer_share');
    url.searchParams.set('utm_medium', 'web_share');
    url.searchParams.set('utm_campaign', 'routine_pdp');

    return url.toString();
  }

  function setBusy(button, busy) {
    button.disabled = busy;

    if (busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  function showStatus(button, message) {
    var container = button.closest('.luxi-pdp-routine-share');
    var status = container
      ? container.querySelector('[data-luxi-pdp-share-status]')
      : null;

    if (!status) return;

    if (button.luxiShareStatusTimer) {
      window.clearTimeout(button.luxiShareStatusTimer);
    }

    status.textContent = message || '';

    if (message) {
      button.luxiShareStatusTimer = window.setTimeout(function () {
        status.textContent = '';
      }, 4000);
    }
  }

  function trackShare(button, title, shareUrl, method) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'luxiface_routine_pdp_share',
      routine_title: title,
      routine_url: shareUrl,
      product_id: button.dataset.productId || '',
      product_handle: button.dataset.productHandle || '',
      share_method: method
    });
  }

  function copyRoutine(button, fullText, title, shareUrl) {
    return copyText(fullText)
      .then(function () {
        showStatus(button, 'Routine link copied.');
        trackShare(button, title, shareUrl, 'copy');
      })
      .catch(function () {
        window.prompt('Copy this routine link:', shareUrl);
        showStatus(button, 'Copy the routine link shown above.');
      });
  }

  function shareRoutine(button) {
    var title =
      button.dataset.shareTitle ||
      'Luxiface Korean skincare routine';

    var shareUrl = buildShareUrl(button.dataset.shareUrl);

    var shareText =
      'I found this Luxiface-curated Korean skincare routine and thought it might interest you:\n' +
      title;

    var fullText = shareText + '\n' + shareUrl;

    var shareData = {
      title: title + ' | Luxiface',
      text: shareText,
      url: shareUrl
    };

    setBusy(button, true);
    showStatus(button, '');

    if (typeof navigator.share === 'function') {
      var sharePromise;

      try {
        sharePromise = navigator.share(shareData);
      } catch (error) {
        sharePromise = Promise.reject(error);
      }

      sharePromise
        .then(function () {
          showStatus(button, 'Share menu opened.');
          trackShare(button, title, shareUrl, 'native');
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;

          return copyRoutine(
            button,
            fullText,
            title,
            shareUrl
          );
        })
        .then(
          function () {
            setBusy(button, false);
          },
          function () {
            setBusy(button, false);
          }
        );

      return;
    }

    copyRoutine(button, fullText, title, shareUrl).then(
      function () {
        setBusy(button, false);
      },
      function () {
        setBusy(button, false);
      }
    );
  }

  function initialiseButton(button) {
    if (
      !button ||
      button.dataset.luxiPdpShareInitialised === 'true'
    ) {
      return;
    }

    button.dataset.luxiPdpShareInitialised = 'true';
    button.hidden = false;

    button.addEventListener('click', function () {
      shareRoutine(button);
    });
  }

  function initialise(scope) {
    var buttons = [];

    if (
      scope.matches &&
      scope.matches('[data-luxi-pdp-routine-share]')
    ) {
      buttons.push(scope);
    }

    if (scope.querySelectorAll) {
      buttons = buttons.concat(
        Array.prototype.slice.call(
          scope.querySelectorAll(
            '[data-luxi-pdp-routine-share]'
          )
        )
      );
    }

    buttons.forEach(initialiseButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialise(document);
    });
  } else {
    initialise(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialise(event.target);
    }
  );
})();